import React, { useState,useEffect } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck,dateFormate,currencyFormat } from "utils/columns";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import useAxios from "hooks/useAxios";
import AttachIcon from 'assets/icon/icon-icon-options-attachment.svg';
import AttachHoverIcon from 'assets/icon/icon-icon-options-attachment_hover.svg';
import Drawer from "components/Drawer";
import ProgramNotes from "components/ProgramNotes";
import { Button } from "reactstrap";
import HoverImage from "react-hover-image/build";


let rowForEdit = {};
let accountTypeData = [];
const RxManagerTable = (props)=>{

  const {toggleSider,orgId ,search,detailsData,totalItem,} = props
const [tableData,setTableData]= useState([]);
   const [commentDrawer, setCommentDrawer] = useState(false);
const API = useAxios();
useEffect(()=>{
setTableData(detailsData);
},[detailsData])
useEffect(()=>{
fetchAccountType();
},[])
const cellRenderEdit = (rowData) => {
      return (
        <div className="d-flex align-items-center">
          {cellRenderEdit1(rowData)}
          {renderAttachementsButton(rowData)}
        
        </div>
      );
  };
  const fetchAccountType = async () => {
    accountTypeData= [];
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/accountType`, {
        hasDefaultURL: true,
      });

      if (data) {
        for (var x in data) {
          accountTypeData.push({
            id: data[x].id,
            label: data[x].description,
          });
        }
        accountTypeData.push({  id: null,
            label: "Pending",})
        
       // setAccountType(data);
      } else {
     //   setAccountType([]);
      }
    } catch (err) { }
  };
  const cellRenderEdit1 = (row) => {
  
      return <CellOptions row={row} onEdit={editRow}  />;
  };
  const editRow = (rowData, isEdit = true) => {
  //  setRedflag("");
    let tempData = [...tableData];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.claimID === rowData?.claimID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    //tableDataBackup = tempData;
    setTableData(tempData);
  };
  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
    const formatter = (
      row,
      col,
      formatterType,
      alwaysEditableCheckbox,
      
    ) => {
      return (
        <CellEditRender
          row={row}
          col={col}
          alwaysEditableCheckbox={alwaysEditableCheckbox}
          formatterType={formatterType}
          onChange={updateRowValue}
          listArray={accountTypeData}
        />
      );
    };
let utilizationcoloums = [
        {
            dataField: 'options',
            text: 'Options',
            sort: false,
            width: 120,
            show: true,
            cellRenderer: (rowData) => cellRenderEdit(rowData),

            hidecolFilter: true,
            action: true
        },
        {
            dataField: 'claimID',
            text: 'Claim ID',
            sort: true,
            width: 200,
            show: true,
            // edit:true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => formatter(rowData,col),
            showColumn: true
        },
        {
            dataField: 'comments',
            text: 'Comments',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.comments),
            showColumn: true
        },
        {
            dataField: 'drugAdminDate',
            text: 'Date of Drug Administration',
            sort: true,
            width: 200,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (rowData, col) => `${('0' + (new Date(rowData.drugAdminDate).getMonth() + 1)).slice(-2)}/${('0' + new Date(rowData.drugAdminDate).getDate()).slice(-2)}/${new Date(rowData.drugAdminDate).getFullYear()} ${('0' + new Date(rowData.drugAdminDate).getHours()).slice(-2)}:${('0' + new Date(rowData.drugAdminDate).getMinutes()).slice(-2)}`,
            showColumn: true
        },
        {
            dataField: 'mrNumber',
            text: 'MR Number',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.mrNumber),
            showColumn: true
        },
        {
            dataField: 'accountType',
            text: 'Account Type',
            sort: false,
            width: 120,
            show: true,
            edit:true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (rowData, col) => rowData.isEdit == true ?formatter(rowData,col,"statusList") : cellRendererCheck(rowData.accountType === null ? 'Pending' : rowData.accountType),
            showColumn: true
        },
        {
            dataField: 'patientType',
            text: 'Patient Type',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.patientType),
            showColumn: true
        },
        {
            dataField: 'providerNPI',
            text: 'Provider NPI',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.providerNPI ? rowData.providerNPI : '-'),
            showColumn: true
        },
        {
            dataField: 'providerName',
            text: 'Provider Name',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.providerName ? rowData.providerName : '-'),
            showColumn: true
        },
       
        {
            dataField: 'claimReason',
            text: 'Reason',
            sort: true,
            width: 160,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.claimReason),
            showColumn: true
        },
        
      
        {
            dataField: 'visitNumber',
            text: 'Visit Number',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.visitNumber),
            showColumn: true
        },
       

        {
            dataField: 'serviceLocationDesc',
            text: 'Service Location',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.serviceLocationDesc),
            showColumn: true
        },
        {
            dataField: 'chargeCode',
            text: 'Charge Code',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.chargeCode),
            showColumn: true
        },
        {
            dataField: 'chargeDescription',
            text: 'Charge Description',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.chargeDescription),
            showColumn: true
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.ndc ? rowData.ndc : '-'),
            showColumn: true
        },
        {
            dataField: 'drugName',
            text: 'NDC Description',
            sort: true,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugName),
            showColumn: true
        },

        {
            dataField: 'grossCharge',
            text: 'Gross Charge',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => currencyFormat(rowData.grossCharge),
            showColumn: true
        },
        {
            dataField: 'dispensedQuantity',
            text: 'Quantity',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.dispensedQuantity),
            showColumn: true
        },
        {
            dataField: 'bupp',
            text: 'BUPP',
            sort: true,
            width: 120,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.bupp ? rowData.bupp : '-'),
            showColumn: true
        },
        {
            dataField: 'quantity',
            text: 'Accumulation',
            sort: true,
            width: 160,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.quantity),
            showColumn: true
        },
        {
            dataField: 'primaryPayor',
            text: 'Primary Payor',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.primaryPayor),
            showColumn: true
        },

        {
            dataField: 'secondaryPayor',
            text: 'Secondary Payor',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.secondaryPayor),
            showColumn: true
        },

        {
            dataField: 'tertiaryPayor',
            text: 'Tertiary Payor',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.tertiaryPayor),
            showColumn: true
        },
        {
            dataField: 'drugExclusionReason',
            text: 'Drug Exclusion Type',
            sort: true,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.drugExclusionReason ? rowData.drugExclusionReason : '-'),
            showColumn: true
        },
        {
            dataField: 'orphanDrugFlag',
            text: 'Orphan Drug',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.orphanDrugFlag),
            showColumn: true
        },
        {
            dataField: 'admitDate',
            text: 'Admit Date',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.admitDate),
            showColumn: true
        },
        {
            dataField: 'dischargeDate',
            text: 'Discharge Date',
            sort: true,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => dateFormate(rowData.dischargeDate),
            showColumn: true
        },
        {
            dataField: 'facility',
            text: '	Facility',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.facility),
            showColumn: true
        },
        {
            dataField: 'hcpcsjcode',
            text: 'HCPCS ',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.hcpcsjcode),
            showColumn: true
        },
        {
            dataField: 'transactionID',
            text: 'Transaction ID',
            sort: true,
            width: 180,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.transactionID),
            showColumn: true
        },
        {
            dataField: 'usedHL7',
            text: 'ADT Used',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.usedHL7),
            showColumn: true
        },
        {
            dataField: 'fileProcessName',
            text: 'File Name',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (rowData, col) => cellRendererCheck(rowData.fileProcessName),
            showColumn: true
        }
    ]

    const toggleAttachPODetailsDrawer = () => {
        setCommentDrawer(!commentDrawer);
        // setDrawerPODetails('');
      };
      const renderAttachementsButton = (rowData) => {
      //  if (hasPermission('AT'))
           return (
           <Button
               className='text-primary p-0 text-decoration-none'
               color='link'
               onClick={() => toggleAttachPODetailsDrawer(rowData)}
               title="Comment"
           >
               <HoverImage
                   key='AttachIcon'
                   src={AttachIcon}
                   hoverSrc={AttachHoverIcon}
                   alt=''
               />
           </Button>
           )
   }
   const onExport = ()=>{
    return true;
   }
    return(
        <div
        className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
    >
        <ReactStrapTable
            id='reportdetails-table'
            data={tableData}
            columns={utilizationcoloums}
            hasPagination
            pageSize={search.pageSize}
            currentPage={search.currentPage}
            totalRecords={totalItem}
            filters={search}
          //  handleSort={handleSort}
          onExport={onExport}
          //  onSearchColumnFilters={handleSearchColumnFilters}
           // onFilterCancel={handleFilterCancel}
           // collapseSider={collapseSider}
        toggleSider={toggleSider}
            showtoggle={true}
        />
        <Drawer
        direction="end"
        title="Add Utilization Comment"
        isOpen={commentDrawer}
        toggle={toggleAttachPODetailsDrawer}
        size="lg"
      >
        <ProgramNotes orgId = {orgId}    onClose={toggleAttachPODetailsDrawer}
                    selectedCoveredEntity={1}/>
      </Drawer>
    </div>    )
}
export default RxManagerTable;